<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :close-on-click-modal="closeOnClickModal"
    @open="onOpen"
    @close="onClose"
  >
    <lab-experiment-2-user-list
      ref="list"
      :lesson-uid="lessonUid"
      :lesson-exp-uid="lessonExpUid"
    />

    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">关 闭</el-button>
      <el-button type="primary" @click="handleDownload">下 载</el-button>
    </span>
  </el-dialog>
</template>

<script>
import LabExperiment2UserList from "../LabExperiment2UserList.vue";
export default {
  name: "LabExperiment2UserListDialog",
  components: {
    LabExperiment2UserList,
  },
  data() {
    return {
      // 基本数据
      title: "课堂实验成绩明细",
      visible: false,
      closeOnClickModal: false,
      // 业务数据
      lessonUid: "", // 课堂uid
      lessonExpUid: "", // 课堂实验uid
    };
  },
  methods: {
    onOpen() {
      // do something
    },
    onClose() {
      this.lessonExpUid = "";
      this.$refs.list.loading = false;
    },
    handleDownload() {
      this.$refs.list.download(this.title);
    },
  },
};
</script>